// Constants
const initialTargetAudienceData = {
  gender: null,
  ageGroup: [0, 8],
  datasource: ``,
};

export default initialTargetAudienceData;
